module.exports = {"title":"Tous les livres","desc":"Liste de tous les livres de la maison d'édition ISBA"}